import { useI18n } from "@/lib/i18n";
import { useInView } from "@/hooks/useInView";
import aboutPhotoAsset from "@/assets/about-villas-skyline.webp.asset.json";
const aboutPhoto = aboutPhotoAsset.url;

const AboutSection = () => {
  const { t, lang } = useI18n();
  const [ref1, inView1] = useInView();
  const [ref2, inView2] = useInView();


  return (
    <section id="about" className="py-16 md:py-24 bg-navy relative overflow-hidden">
      <div className="absolute top-0 left-0 w-96 h-96 bg-cream/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-cream/5 rounded-full blur-3xl translate-x-1/2 translate-y-1/2" />

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-10 md:gap-16 items-center">
          <div
            ref={ref1}
            className={`${lang === "en" ? "anim-fade-left" : "anim-fade-right"} ${inView1 ? "in-view" : ""}`}
          >
            <h2 className={`text-4xl md:text-5xl font-black text-cream mb-6 ${lang === "en" ? "font-houstiq" : ""}`}>
              {t("about.title")} <span className="text-cream">{t("about.titleHighlight")}</span>
            </h2>
            <p className="text-cream/60 leading-loose text-lg mb-6">{t("about.p1")}</p>
            <p className="text-cream/60 leading-loose text-lg mb-10">{t("about.p2")}</p>
          </div>

          <div
            ref={ref2}
            className={`relative ${lang === "en" ? "anim-fade-right" : "anim-fade-left"} ${inView2 ? "in-view" : ""}`}
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img src={aboutPhoto} alt="فلل صحار وقت الغروب مع أفق الرياض" loading="lazy" width={1600} height={900} className="w-full h-[350px] md:h-[500px] object-cover object-[49%_center]" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/40 to-transparent" />
            </div>
            <div className={`w-fit ms-auto mt-4 md:mt-0 md:absolute md:ms-0 md:-bottom-6 ${lang === "en" ? "md:-right-6" : "md:-left-6"} bg-cream text-navy font-bold rounded-2xl p-4 md:p-6 shadow-2xl`}>
              <div className="text-2xl md:text-3xl font-black">+5</div>
              <div className="text-xs md:text-sm">{t("about.badge")}</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
